// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup, Form, FormFeedback } from 'reactstrap';
import { ColorSquare } from '../containers/ColorSquare'; 
import { ImageSquare } from '../containers/ImageSquare'; 

//COMPONENT

class SegmentCreationModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            selectedColor: '',
            selectedIcon: '',
            isNameValid: true,
            isColorValid: true,
            isImageValid: true,
            invalidNameMessage: '',
            colours: ['#34CB64','#64C3F8','#F85858','#338AFF','#F8893D','#BB78EB','#FFDB0C','#F874A8'],
            icons: ['cafe.png', 'dairy.png', 'fastfood.png', 'restaurant.png', 'supermarket.png', 'pizza.png', 'bakery.png', 'chicken.png', 'sushi.png', 'sandwich.png', 'asain.png', 'fish.png', 'kebab.png']
        };

        this.nameChange = this.nameChange.bind(this);
        this.typeChange = this.typeChange.bind(this);
        this.createSegment = this.createSegment.bind(this);
        this.colorSelected = this.colorSelected.bind(this);
        this.imageSelected = this.imageSelected.bind(this);
    }

    nameChange(e){
        this.setState({name: e.target.value});
        this.validateInput(e.target.value);
    }

    typeChange(e){
        this.setState({type: e.target.value.toLowerCase()});
    }

    validateInput(input){
        var foundName = false;
        var message = '';
        for (var segmentId in this.props.segments) {
            if (this.props.segments[segmentId].name.toLowerCase() == input.toLowerCase()) {
                foundName = true;
                message = 'a segment with this name already exists';
            }
        }
        
        this.setState({
            isValid: !foundName,
            invalidNameMessage: message
        });
    }

    createSegment(){
        if (this.state.name == '' || this.state.selectedColor == '' || this.state.selectedIcon == '') {
            this.setState({
                isNameValid: !this.state.name == '',
                isColorValid: !this.state.selectedColor == '',
                isImageValid: !this.state.selectedIcon == '',
                invalidNameMessage: this.state.name == '' ? 'You must enter a name for this segment' : ''
            });
        } else {
            if(this.state.isValid) {
                this.props.createSegmentFromInput(this.state.name, this.state.selectedColor, this.state.selectedIcon);
                this.props.toggleCreateModal();
            }
        }
    }

    colorSelected(color){
        if(color == this.state.selectedColor){
            this.setState({selectedColor: ''});
        } else {
            this.setState({
                selectedColor: color,
                isColorValid: true
            });
        }
    }

    imageSelected(image){
        if(image == this.state.selectedIcon){
            this.setState({selectedIcon: ''});
        } else {
            this.setState({
                selectedIcon: image,
                isImageValid: true
            });
        }
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>New Segment</ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup>
                                <Label for="segmentName">Name</Label>
                                <Input invalid={!this.state.isNameValid} type="text" name="segment-name" id="segmentName" placeholder="Name" onChange={this.nameChange} value={this.state.name} />
                                <FormFeedback>{this.state.invalidNameMessage}</FormFeedback>
                            </FormGroup>

                            <FormGroup>
                                <Label for="colorLabel">Color</Label>
                                <div className="color-selection-container">
                                    {this.state.colours.map((color) => { return( <ColorSquare key={color} isSelected={this.state.selectedColor == color} color={color} colorSelected={this.colorSelected}/>);})}
                                </div>
                                <FormFeedback>You must select a color</FormFeedback>
                            </FormGroup>
                            
                            <FormGroup>
                                <Label for="typeSelect">Icon</Label>
                                <div className="image-selection-container">
                                    {this.state.icons.map((icon) => { return( <ImageSquare key={icon} isSelected={this.state.selectedIcon == icon} image={icon} imageSelected={this.imageSelected}/>);})}
                                </div>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="button" color="secondary" onClick={this.props.toggleCreateModal}>Cancel</Button>
                        <Button className="button segment-submit-btn" onClick={this.createSegment}>Create</Button>{' '}
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

SegmentCreationModal.propTypes = {
    history: PropTypes.object.isRequired,
    segments: PropTypes.array.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleCreateModal: PropTypes.func.isRequired,
    createSegmentFromInput: PropTypes.func.isRequired
};

const hoc = withRouter(SegmentCreationModal);

// EXPORT COMPONENT
export { hoc as SegmentCreationModal };


// WEBPACK FOOTER //
// ./src/components/modals/SegmentCreationModal.js